import axios from 'axios';
import { API_REPORTES } from 'config/general/Configuracion';
import { ID_CUENTA } from 'config/general/Configuracion';
import { API_DASHBOARD } from 'config/general/Configuracion';
import { HEADERS } from 'config/general/Configuracion';


export const getDatosSolicitarListarOcupacionCiudad = async () => {
  const cuenta = localStorage[ID_CUENTA];
  const url = `${API_DASHBOARD}/v1/dashboard/ciudad/ocupacion/${cuenta}`;
  try {
    const response = await axios.get(url, {
      headers: HEADERS()
    });
    return response.data;
  } catch (error) {
    console.error("Error al consultar ocupación por ciudad:", error);
    throw error;
  }
};

export const getRegistroActualVehiculo = async (placa) => {
  const cuenta = localStorage[ID_CUENTA];
  const url = `${API_REPORTES}/v1/reportes/ciudad/mi-registro/${cuenta}/${placa}`;
  try {
    const response = await axios.get(url, {
      headers: HEADERS()
    });
    return response.data;
  } catch (error) {
    console.error("Error al consultar ocupación por ciudad:", error);
    throw error;
  }
};

